import { createI18n } from 'vue-i18n'

export function i18nForCookieConsent() {
  let locale = window.default_locale;
  let fallbackLocale = window.fallback_locale;
  let messages = window.messages || {};

  const cookieconsentLocaleEl = document.documentElement.querySelector('#cookieconsent');
  if (!cookieconsentLocaleEl) {
    return createI18n({
      locale,
      fallbackLocale,
      messages
    });
  }
  const cookieconsentLocaleConfig = JSON.parse(cookieconsentLocaleEl.innerHTML);
  if (!locale) {
    locale = cookieconsentLocaleConfig.locale;
    fallbackLocale = cookieconsentLocaleConfig.locale;
  }

  messages = cookieconsentLocaleConfig.messages;

  // for (const l in cookieconsentLocaleConfig.messages) {
  //   const cookieconsentMessages = cookieconsentLocaleConfig.messages[l];
  //   for (const key in cookieconsentMessages) {
  //     messages[`${l}.${key}`] = cookieconsentMessages[key];
  //   }
  // }

  return createI18n({
    locale,
    fallbackLocale,
    messages
  });
}
